export default "__VITE_ASSET__082d9dd8__"